import { render, staticRenderFns } from "./study-certificate-query.vue?vue&type=template&id=6a06c071&scoped=true&"
import script from "./study-certificate-query.vue?vue&type=script&lang=js&"
export * from "./study-certificate-query.vue?vue&type=script&lang=js&"
import style0 from "./study-certificate-query.vue?vue&type=style&index=0&id=6a06c071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06c071",
  null
  
)

export default component.exports